export class Category {
	constructor(tree, lang) {
		this.tree = tree;
		this.lists = [];
		this.paths = [];
		this.lang = lang;
	}

	async build() {
		await this.loop(this.tree[0]);
	}
	async loop(child) {
		const name = child.trans.find(el => el.lang === this.lang);
		this.paths.push({
			_id: child._id,
			id: child.id,
			name: name?.name ? name.name : 'Default',
			parent: child?.parent?._id,
		});

		if (child?.children?.length > 0) {
			for await (let line of child?.children) {
				await this.loop(line);
			}
		} else {
			const name = child.trans.find(el => el.lang === this.lang);
			this.lists.push({
				_id: child._id,
				id: child.id,
				name: name?.name ? name.name : 'Default',
				parent: child?.parent?._id,
				paths: [],
			});
		}
	}
	async buildTotal() {
		await this.loopTotal(this.tree[0]);
	}
	async loopTotal(child) {
		if (!child?.trans) {
			return;
		}
		const name = child.trans.find(el => el.lang === this.lang);
		this.paths.push({
			_id: child._id,
			name: name?.name ? name.name : 'Default',
			parent: child?.parent?._id,
			parentid: child?.parent?.id,
			id: child?.id,
		});

		this.lists.push({
			_id: child._id,
			name: name?.name ? name.name : 'Default',
			parent: child?.parent?._id,
			paths: [],
			id: child.id,
			parentid: child?.parent?.id,
		});
		if (child?.children?.length > 0) {
			for await (let line of child?.children) {
				await this.loopTotal(line);
			}
		}
	}
	async refactorCategory() {
		for await (let refactor of this.lists) {
			const parent = this.paths.find(el => el._id.toString() === refactor.parent.toString());
			if (parent) {
				refactor.paths.push(parent.name);
				await this.loopRefactorCategory(refactor, parent);
			}
		}
	}
	async loopRefactorCategory(refactor, parent) {
		const parentSub = this.paths.find(el => el._id.toString() === parent.parent.toString());
		if (parentSub) {
			refactor.paths.push(parentSub.name);
			if (parentSub.name !== 'parent' && parentSub.name !== 'root') {
				await this.loopRefactorCategory(refactor, parentSub);
			}
		} else {
			return;
		}
	}
	async dynamicSort() {
		this.lists.sort((a, b) => (a.string.toLowerCase() < b.string.toLowerCase() ? -1 : 1));
	}

	async createPath() {
		for await (let list of this.lists) {
			list.paths = list.paths.reverse();
			await list.paths.shift();
			list.paths.push(list.name);
			list.string = list.paths.join(' \\ ').trim();
		}
	}

	get getTree() {
		return this.lists;
	}
	get getPath() {
		return this.paths;
	}
}
